// src/components/GlobalWebSocketListener.jsx
import { useEffect, useCallback } from 'react';
import { useNotification } from './NotificationContext';
// At the top of the file
const ALLOWED_ORDER_TYPES = ['DELIVERY'];
const ALLOWED_STATUSES = ['HOLD', 'PENDING', 'CONFIRMED', 'PROCESSING',
    'BEING_PREPARED', 'ORDER_IS_READY',
    'WAITING_FOR_PICKUP', 'ON_THE_WAY'];
const GlobalWebSocketListener = () => {
    const { addNotification } = useNotification();

    const handleWebSocketMessage = useCallback((event) => {
        //console.log('🌍 Global WebSocket listener received:', event.detail);
        const { topic, data } = event.detail;

        // 🍽️ Handle Food orders (admin-all-orders)
        if (topic === 'admin-all-orders') {
            //console.log('🍽️ New food order detected globally');

            let orderCount = 0;

            if (Array.isArray(data)) {
                // ✅ Filter for DELIVERY orders with allowed statuses
                const filteredOrders = data.filter(order => {
                    const status = order.status?.toUpperCase() || '';
                    const orderType = order.orderType?.toUpperCase() || '';
                    return ALLOWED_STATUSES.includes(status) && ALLOWED_ORDER_TYPES.includes(orderType);
                });

                orderCount = filteredOrders.length;
            } else if (data && typeof data === 'object') {
                const status = data.status?.toUpperCase() || '';
                const orderType = data.orderType?.toUpperCase() || '';

                // ✅ Check both status AND orderType
                if (ALLOWED_STATUSES.includes(status) && ALLOWED_ORDER_TYPES.includes(orderType)) {
                    orderCount = 1;
                }
            }

            if (orderCount > 0) {
                //console.log(`🔔 Adding ${orderCount} notification(s) for "Live orders" tab (DELIVERY orders only)`);
                addNotification('Live orders', orderCount);
            }
        }

        // 🛵 Handle Delivery orders (admin-assigned-orders) - Keep as is
        // if (topic === 'admin-assigned-orders') {
        //     //console.log('🛵 New delivery order detected globally');
        //     // This is already DELIVERY orders from delivery service
        //     let orderCount = 0;

        //     if (Array.isArray(data)) {
        //         orderCount = data.length;
        //     } else if (data && typeof data === 'object') {
        //         orderCount = 1;
        //     }

        //     if (orderCount > 0) {
        //         //console.log(`🔔 Adding ${orderCount} notification(s) for "Delivery orders" tab`);
        //         addNotification('Delivery orders', orderCount);
        //     }
        // }
    }, [addNotification]);

    // Set up global listener
    useEffect(() => {
        //console.log('🌍 Global WebSocket Listener MOUNTED - Always listening!');

        // Check WebSocket connection status
        const wsStatus = window.adminWebSocketService?.isConnected?.();
        //console.log(`🔗 WebSocket status: ${wsStatus ? '✅ Connected' : '❌ Not connected'}`);

        // Add the global event listener
        window.addEventListener('admin-websocket-message', handleWebSocketMessage);

        //console.log('✅ Global listener added successfully');

        return () => {
            //console.log('🧹 Global WebSocket Listener UNMOUNTED');
            window.removeEventListener('admin-websocket-message', handleWebSocketMessage);
            //console.log('✅ Global listener removed');
        };
    }, [handleWebSocketMessage]);

    // This component doesn't render anything
    return null;
};

export default GlobalWebSocketListener;